import { Link } from 'react-router-dom';
import type { ExternalSums } from 'modules/guarantee/types';
import { dateFrom, dateTo } from 'components/columns';
import { ControlledTableColumns, flexColumn } from 'components/ControlledTable';

export const columns: ControlledTableColumns<ExternalSums> = [
  {
    content: 'Number',
    key: 'number',
    required: true,
    width: 120,
    render: ({ id, number }: ExternalSums) => <Link to={`${id}`}>{number}</Link>,
  },
  flexColumn({
    content: 'Agency',
    key: 'agency.company.title',
  }),
  dateFrom(),
  dateTo(),
];
